// helpers
import { log } from 'shared/helpers/newRelic';

// constants
import { ERROR_TAGS } from 'shared/helpers/SentryLogger/constants';

// defs
import { Customer } from 'shared/types/customer';

export const transformCustomer = (data: any) => {
  try {
    let customerData = undefined;

    if (data.customerData) {
      customerData = {
        email: data.customerData.email,
        firstName: data.customerData.firstname,
        lastName: data.customerData.lastname,
        id: data.customerData.id,
        mobile: data.customerData.mobile,
        hideEmail: data.customerData.hideEmail !== undefined ? data.customerData.hideEmail : false,
      };
    }

    return {
      baseLocation: data?.base_location || 'IN',
      cartCount: data?.cartCount || 0,
      formKey: data?.form_Key || '',
      customerData,
    } as Customer;
  } catch (e) {
    log({
      errTitle: 'Error in transformCustomer - Provider',
      tags: { module: ERROR_TAGS.TRANFORMER },
      extra: { transformer: 'Customer Transformer' },
    });
    throw e;
  }
};
